export const validateBucketName = (bucketName: string): boolean => {
  if (bucketName.length < 3 || bucketName.length >= 63) {
    return false;
  } else {
    // Bucket name can consist only of lowercase letters, numbers, and hyphens (-).
    const regex = new RegExp(/^[\da-z-]+$/);
    return regex.test(bucketName);
  }
};
